import { get } from '@/api/axios/index.js'

/**
 * 查询已发布的业务字典。
 * q 的编码规则见项目根目录《字典.md》：UTF-8 JSON + Base64 URL-safe。
 */
export function queryBusinessDictionary(q) {
  return get('/dictionary-api/query', { q: encodeDictionaryQuery(q) })
}

function encodeDictionaryQuery(data) {
  const bytes = new TextEncoder().encode(JSON.stringify(data))
  let binary = ''

  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte)
  })

  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '')
}
